import React from 'react';
import './Question.css';
import Faq from './Faq/Faq';

export type FaqItem = {
  id: string;
  question: string;
  answer: string;
};

type Props = {
  items?: FaqItem[];
  title?: string;
};

const items = [
  {
    id: 'q1',
    question: 'Τι ίσχυε μέχρι τώρα;',
    answer: 'Μέχρι πριν την ισχύ του τελευταίου νόμου ένας εντεταλμένος υπάλληλος της υπηρεσίας σημάτων έκρινε ως προς την ομοιότητα ή μη των νέων σημάτων. Έτσι κατοχυρώνονταν σήματα που σας δημιουργούσαν προβλήματα και τα ανακάλυπτε ο δικαιούχος μετά από σχετικά μεγάλα χρονικά διαστήματα. Αποτέλεσμα να αναγκάζεται ο δικαιούχος του προγενέστερου σήματος να καταφεύγει (πολυδάπανα) στη δικαιοσύνη της οποίας οι υποθέσεις τελεσιδικούσαν μετά από πολλά χρόνια και με μεγάλη διπλή ζημιά.',
  },
  {
    id: 'q2',
    question: 'Τι ισχύει τώρα;',
    answer: 'Ο Νόμος 4679/2020 μετασχηματίζει τον ρόλο σας από παθητικό σε ενεργό προστάτη του brand σας. Σας δίνει τη δύναμη να είστε εσείς ο φύλακας της επένδυσής σας, αντιδρώντας άμεσα σε κάθε απειλή. Για να το πετύχετε αυτό, η ενεργή και συστηματική παρακολούθηση των σημάτων είναι πλέον κρίσιμη.',
  },
  {
    id: 'q3',
    question: 'Μπορώ να κάνω και μόνος τον έλεγχο;',
    answer: 'Θεωρητικά, ναι, μπορείτε να το κάνετε. Πρακτικά, όμως, η διαδικασία είναι απαιτητική. Για να είστε πλήρως καλυμμένοι, θα πρέπει να ελέγχετε σε τακτά και πυκνά χρονικά διαστήματα τις βάσεις ανακοινώσεων του ΟΒΙ και του EUIPO, ώστε να μη χαθεί καμία προθεσμία για πιθανή αντίδραση. Η παρακολούθηση απαιτεί συνέπεια, εμπειρία και εξοικείωση με τη νομική διαδικασία.',
  },
  {
    id: 'q4',
    question: 'Τι γίνεται αν χαθεί προθεσμία;',
    answer: 'Αρχικά να σας ενημερώσουμε ότι με το Trademark Radar οι έλεγχοι είναι καθημερινοί οπότε και δική σας ενημέρωση. Επιπλέον εμείς θα σας ενημερώσουμε για την προθεσμία λήψης μέτρων έτσι ώστε να μην χάσετε καμία προθεσμία. Οι ειδοποιήσεις μας φέρουν ξεκάθαρα την καταληκτική ημερομηνία. Εάν εσείς δεν αποφασίσετε να αντιδράσετε έγκαιρα εμείς θα σας προτείνουμε εναλλακτικές οι οποίες όμως θα είναι πιο κοστοβόρες γιατί θα απαιτούν περισσότερο χρόνο και χρήμα μέχρι τη λύση του προβλήματος.',
  },
  {
    id: 'q5',
    question: 'Πώς λειτουργεί το Trademark Radar;',
    answer: 'Χαρτογραφούμε το σήμα σας —λεκτικό ή/και εικαστικό και σχετικές περιγραφές— και ρυθμίζουμε αλγόριθμο αναζήτησης. Παρακολουθούμε δημοσιεύσεις και εντοπίζουμε πιθανές συγκρούσεις. Όταν κάτι μοιάζει επικίνδυνα, λαμβάνετε ειδοποίηση με εκτίμηση ρίσκου και συγκεκριμένες επιλογές αντίδρασης.',
  },
  {
    id: 'q6',
    question: 'Πόσο αξιόπιστοι είναι οι αλγόριθμοι ομοιότητας;',
    answer: 'Συνδυάζουμε αυτοματισμό με ανθρώπινη κρίση. Κάθε εύρημα αξιολογείται από εξειδικευμένο συνεργάτη πριν σταλεί, ώστε να αποφεύγονται ψευδώς θετικά/αρνητικά. Τους έχουμε δοκιμάσει στην πράξη (τα δύο τελευταία χρόνια) και ήδη έχουν ενταχθεί στην υπηρεσία περισσότερα από 2.000 εμπορικά σήματα έχοντας εντοπίσει και ενημερώσει για περισσότερες από 3.500 υποθέσεις.',
  },
  {
    id: 'q7',
    question: 'Σε ποιες βάσεις γίνεται έλεγχος;',
    answer: 'Σε ΟΒΙ (Οργανισμός Βιομηχανικής Ιδιοκτησίας) για τα Εθνικά σήματα και σε EUIPO (Γραφείο σημάτων της Ευρωπαϊκής Ένωσης) για κατοχυρώσεις που μπορεί να επηρεάσουν την προστασία σας στην EU/GR, ανάλογα με την κατοχύρωση του Εμπορικού Σήματός σας.',
  },
  {
    id: 'q8',
    question: 'Τι δεν καλύπτει το Trademark Radar;',
    answer: 'Η υπηρεσία εντοπίζει και ειδοποιεί. Ο τρόπος αντίδρασης σας και οι πιθανές ενέργειες τις οποίες εσείς θα αποφασίσετε να κάνετε δεν περιλαμβάνονται στην ένταξή σας στην υπηρεσία.',
  },
  {
    id: 'q9',
    question: 'Τι περιλαμβάνει μια ειδοποίηση;',
    answer: 'Σας αποστέλλουμε με email αντιγραφο του συγκρουόμενου εμπορικού σήματος με τα στοιχεία του υποψηφίου δικαιούχου, όπως αυτά εμφανίζονται στο αρχείο εμπορικών σημάτων. Επιπλέον σας ενημερώνουμε για τις ακριβείς ημερομηνίες μέσα στις οποίες μπορείτε να αντιδράσετε ώστε να είστε εμπρόθεσμοι. Συνοδεύεται από προτεινόμενη ενέργεια: φιλική επικοινωνία, επιστολή διαμαρτυρίας, ανακοπή ή συμφωνία συνύπαρξης, με εκτίμηση κόστους/χρόνου. Σε όλα τα email που σας στέλνουμε κάνουμε follow up πάντα και τηλεφωνικά.',
  },
];

const Question: React.FC<Props> = ({ items: faqItems = items, title = 'Συχνές Ερωτήσεις' }) => {
  return (
    <section id="faq" className="question-section">
      {/* Background video */}
      <video className="question-video" autoPlay loop muted playsInline>
        <source src="./section-2.mp4" type="video/mp4" />
        Το πρόγραμμα περιήγησής σας δεν υποστηρίζει video.
      </video>
      
      {/* Overlay */}
      <div className="question-overlay"></div>
      
      <Faq items={faqItems} title={title} />
    </section>
  );
};

export default Question;
